import { TerminEventSearchParams } from "@/pages/termin-event-search-page/types";
import UseUrlParams from "@/hooks/use-search-params";
import { NifEvent } from "@/components/blocks/termin-search-block/types";
import { useRef } from "react";


function normalize<T>(v: T | "" | null | undefined): T | undefined {
    return v === "" || v == null ? undefined : (v as T);
}

export function useUpdateTerminEventSearchData({
    setEvents,
    filterData,
    setFilterData,
}: {
    setEvents: (events: NifEvent[]) => void;
    filterData: TerminEventSearchParams;
    setFilterData: (x: TerminEventSearchParams) => void;
}) {
    const { updateUrlParams, removeUrlParam, resetUrlParams } = UseUrlParams();
    const requestId = useRef(0);


    const getNewData = async (params: TerminEventSearchParams) => {
        const id = ++requestId.current;
        try {
            const res = await fetch("/api/EventSearchApi/events", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(params),
            });
            if (!res.ok) throw new Error("Failed to fetch events");
            const json: NifEvent[] = await res.json();
            if (id === requestId.current) setEvents(json);
        } catch (err) {
            console.error("Error updating events", err);
        }
    };

    const updateSearchParams = (params: Partial<TerminEventSearchParams>) => {
        const merged: TerminEventSearchParams = { ...filterData, ...params } as TerminEventSearchParams;

        const cleaned: TerminEventSearchParams = {
            selectedActivity: normalize(merged.selectedActivity),
            selectedDistrict: normalize(merged.selectedDistrict),
            fromDate: normalize(merged.fromDate)?.toString(),
            toDate: normalize(merged.toDate)?.toString(),
            queryText: normalize(merged.queryText),
            terminSearchType: normalize(merged.terminSearchType),
            selectedPageNumber: merged.selectedPageNumber ?? 0,
        } as TerminEventSearchParams;

        updateUrlParams(cleaned);

        Object.keys(cleaned).forEach((key) => cleaned[key as keyof TerminEventSearchParams] === undefined && removeUrlParam(key));

        setFilterData(cleaned);
        getNewData(cleaned);
    };

    const resetFilter = () => {
        resetUrlParams();
        setFilterData({});
        getNewData({});
    };


    return { updateSearchParams, resetFilter };
}